module.exports = __webpack_public_path__ + "img/rank_platinium.e559a6f8.png";